import axios from 'axios';
import createdStore from '../store/store';
import { getCookie } from './persistence';

function getHeaders(): object {
  const token = createdStore.store.getState().checkout.token || getCookie('token');
  const acceptHeader = 'application/json, text/plain, */*;';
  const acceptToken = ` api-token:${token}`;
  return {
    Accept: `${acceptHeader} ${token && acceptToken}`,
  };
}

let instance: any;

/**
 * Create a new instance of axios with the provided config
 * @param baseURL, client API endpoint
 */
export function createRestInstance(baseURL: string): any {
  instance = axios.create({ baseURL, withCredentials: false });
}

export const rest = {
  httpGet: (url: string) => instance.get(url, {
    headers: getHeaders(),
  }),
  httpPost: (url: string, data?: object) => instance({
    method: 'post',
    url,
    data,
    headers: getHeaders(),
  }),
  httpPut: (url: string, data?: object) => instance({
    method: 'put',
    url,
    data,
    headers: getHeaders(),
  }),
  httpDelete: (url: string, data?: object) => instance({
    method: 'delete',
    url,
    data,
    headers: getHeaders(),
  }),
};

/* eslint no-plusplus: ["error", { "allowForLoopAfterthoughts": true }] */
/**
 * Returns an object with query paramteters as keys and values
 * @param queryString
 */
export function getQueryParametersAsObject(queryString: string): any {
  if (!queryString || queryString.length <= 1) {
    return {};
  }

  let qs: any = queryString.substr(1);
  qs = qs.split(/&|#/);
  const obj = {};
  for (let i = 0; i < qs.length; i++) {
    qs[i] = qs[i].split('=');
    obj[qs[i].shift()] = decodeURIComponent(qs[i].join('='));
  }
  return obj;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/apiUtils.ts